// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* 
// ─────────────────────────────────────────────────────────────────────────────
// HOME PAGE STYLES
// Below-the-fold styles for the homepage that load after critical styles.
// The first section of the home page should go in critical.scss, while the
// rest of the home page styles go in here.
// ─────────────────────────────────────────────────────────────────────────────
*/

/* ******************* */
/*       FEATURES      */
/* ******************* */

@media only screen and (min-width: 0rem) {
  #features {
    .title {
      margin-bottom: 0;
      line-height: 1.4em;
    }

    .text {
      margin-bottom: calc(16 / 16 * 1rem);
      font-size: 0.8125rem;
      line-height: 2em;
    }

    .container {
      width: 100%;
      max-width: calc(1280 / 16 * 1rem);
      margin: auto;
      display: flex;
      flex-direction: column;
      align-items: center;
      /* 48px - 64px */
      gap: clamp(3rem, 6vw, 4rem);
    }

    .content {
      /* set text align to left if content needs to be left aligned */
      text-align: left;
      width: 100%;
      max-width: calc(542 / 16 * 1rem);
      display: flex;
      flex-direction: column;
      /* centers content horizontally, set to flex-start to left align */
      align-items: flex-start;
      gap: 1.5rem;
      padding: 0 1.625rem;
      text-align: center;
    }

    .feature-list {
      display: flex;
      flex-direction: column;
      gap: 2.5rem;
      li {
        list-style: none;
        padding-left: 1rem;

        .header {
          display: flex;
          justify-content: flex-start;
          align-items: center;
          gap: 1rem;
          background-color: var(--color-primary-very-light);
          border-radius: 2.4375rem 0 0 2.4375rem;
          margin-bottom: 0.5rem;

          .button-solid {
            padding: 0.5rem 1.5rem;
            border-radius: 2.4375rem;
            font-size: 1rem;
            line-height: 1.4em;
          }

          .button-solid:hover:before {
            width: 0;
          }

          .title {
            font-size: 1rem;
          }
        }

        .text {
          margin-bottom: 0;
          padding-right: 1rem;
        }
      }
    }
  }
}

/* Desktop - 1024px */
@media only screen and (min-width: 64rem) {
  #features {
    padding: 0 10.3125rem;
    .container {
      flex-flow: row;
      justify-content: space-between;
      align-items: flex-start;
      gap: calc(125 / 16 * 1rem);
      margin: auto;
    }

    .content {
      padding: 0;
      flex: 0 0 auto;
      max-width: calc(500 / 16 * 1rem);
    }

    .feature-list {
      flex: 1;
    }

    .feature-list li {
      padding-left: 0;
      .header {
        background-color: transparent;
      }

      .text {
        max-width: calc(449 / 16 * 1rem);
        margin-left: 5.125rem;
      }
    }

    .title {
      text-align: start;
    }

    .text {
      text-align: start;
      font-size: 1rem;
      line-height: 1.625em;
      max-width: calc(350 / 16 * 1rem);
    }

    .content {
      margin: 0;
    }
  }
}

/* ******************* */
/*      REVIEWS        */
/* ******************* */

@media only screen and (min-width: 0rem) {
  #reviews {
    padding: var(--section-padding);
    padding-top: calc(112 / 16 * 1rem);
    .container {
      width: 100%;
      /* max-width: calc(1280 / 16 * 1rem); */
      display: flex;
      flex-direction: column;
      align-items: center;
      /* 48px - 64px */
      gap: clamp(2.5rem, 6vw, 4rem);
    }

    .content {
      /* set text align to left if content needs to be left aligned */
      text-align: center;
      width: 100%;
      display: flex;
      flex-direction: column;
      /* centers content horizontally, set to flex-start to left align */
      align-items: center;

      .title {
        margin-bottom: 0;
      }
    }

    .card-container {
      padding: 0;
      margin: 0;
      padding-top: 4rem;
      display: flex;
      column-gap: calc(20 / 16 * 1rem);
      row-gap: calc(64 / 16 * 1rem);
      overflow: hidden;

      /* For dragging */
      cursor: grab;
      user-select: none;
      scroll-behavior: smooth;
    }

    .card-container.dragging {
      cursor: grabbing;
      scroll-behavior: auto;
    }

    .item {
      text-align: center;
      list-style: none;
      width: 100%;
      max-width: calc(630 / 16 * 1rem);
      background-color: var(--color-gray-50);
      /* Padding L & R - 16px - 32px */
      padding: 0 clamp(1rem, 3.2vw, 2rem) 0;
      /* 32px - 40px */
      padding-bottom: clamp(2rem, 5.4vw, 2.5rem);
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 1.5rem;
      flex-shrink: 0;
    }

    .item-img {
      width: calc(80 / 16 * 1rem);
      height: calc(80 / 16 * 1rem);
      transform: translateY(-50%);
      transform-origin: center;
      margin-bottom: -1.5rem;
    }

    .text {
      font-size: calc(13 / 16 * 1rem);
      line-height: 2em;
      margin: 0;
      padding-bottom: calc(20 / 16 * 1rem);
      color: var(--bodyTextColor);
    }

    .name {
      font-size: calc(16 / 16 * 1rem);
      line-height: 1.5em;
      font-weight: 700;
      width: 40%;
      margin: 0;
      display: block;
      color: var(--headerColor);
    }

    .dots {
      display: flex;
      gap: 0.5rem;
    }

    .dot {
      background: none;
      border-radius: 50%;
      border: 1px solid var(--color-primary);
      width: 12px;
      height: 12px;

      &.active {
        background: var(--color-primary);
      }
    }
  }
}

/* Tablet - 768px */
@media only screen and (min-width: 48rem) {
  #reviews {
    padding-inline: 0;
    .card-container {
      overflow-x: auto;
      overflow-y: hidden;
      scroll-snap-type: x mandatory;
      scrollbar-width: none;

      gap: 2rem;
    }

    .card-container::-webkit-scrollbar {
      display: none;
    }

    .item {
      scroll-snap-align: center;
      max-width: 460px;
      padding-inline: 2.75rem;
    }

    .dots {
      visibility: hidden;
      position: absolute;
    }
  }
}
`, "",{"version":3,"sources":["webpack://./src/local.css"],"names":[],"mappings":"AAAA;;;;;;;CAOC;;AAED,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE;IACE;MACE,gBAAgB;MAChB,kBAAkB;IACpB;;IAEA;MACE,mCAAmC;MACnC,oBAAoB;MACpB,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,iCAAiC;MACjC,YAAY;MACZ,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,gBAAgB;MAChB,2BAA2B;IAC7B;;IAEA;MACE,+DAA+D;MAC/D,gBAAgB;MAChB,WAAW;MACX,gCAAgC;MAChC,aAAa;MACb,sBAAsB;MACtB,kEAAkE;MAClE,uBAAuB;MACvB,WAAW;MACX,mBAAmB;MACnB,kBAAkB;IACpB;;IAEA;MACE,aAAa;MACb,sBAAsB;MACtB,WAAW;MACX;QACE,gBAAgB;QAChB,kBAAkB;;QAElB;UACE,aAAa;UACb,2BAA2B;UAC3B,mBAAmB;UACnB,SAAS;UACT,iDAAiD;UACjD,sCAAsC;UACtC,qBAAqB;;UAErB;YACE,sBAAsB;YACtB,wBAAwB;YACxB,eAAe;YACf,kBAAkB;UACpB;;UAEA;YACE,QAAQ;UACV;;UAEA;YACE,eAAe;UACjB;QACF;;QAEA;UACE,gBAAgB;UAChB,mBAAmB;QACrB;MACF;IACF;EACF;AACF;;AAEA,qBAAqB;AACrB;EACE;IACE,qBAAqB;IACrB;MACE,cAAc;MACd,8BAA8B;MAC9B,uBAAuB;MACvB,0BAA0B;MAC1B,YAAY;IACd;;IAEA;MACE,UAAU;MACV,cAAc;MACd,gCAAgC;IAClC;;IAEA;MACE,OAAO;IACT;;IAEA;MACE,eAAe;MACf;QACE,6BAA6B;MAC/B;;MAEA;QACE,gCAAgC;QAChC,qBAAqB;MACvB;IACF;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;MACjB,eAAe;MACf,oBAAoB;MACpB,gCAAgC;IAClC;;IAEA;MACE,SAAS;IACX;EACF;AACF;;AAEA,wBAAwB;AACxB,wBAAwB;AACxB,wBAAwB;;AAExB;EACE;IACE,+BAA+B;IAC/B,kCAAkC;IAClC;MACE,WAAW;MACX,uCAAuC;MACvC,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,gBAAgB;MAChB,6BAA6B;IAC/B;;IAEA;MACE,+DAA+D;MAC/D,kBAAkB;MAClB,WAAW;MACX,aAAa;MACb,sBAAsB;MACtB,kEAAkE;MAClE,mBAAmB;;MAEnB;QACE,gBAAgB;MAClB;IACF;;IAEA;MACE,UAAU;MACV,SAAS;MACT,iBAAiB;MACjB,aAAa;MACb,gCAAgC;MAChC,6BAA6B;MAC7B,gBAAgB;;MAEhB,iBAAiB;MACjB,YAAY;MACZ,iBAAiB;MACjB,uBAAuB;IACzB;;IAEA;MACE,gBAAgB;MAChB,qBAAqB;IACvB;;IAEA;MACE,kBAAkB;MAClB,gBAAgB;MAChB,WAAW;MACX,gCAAgC;MAChC,sCAAsC;MACtC,gCAAgC;MAChC,qCAAqC;MACrC,gBAAgB;MAChB,0CAA0C;MAC1C,kBAAkB;MAClB,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,WAAW;MACX,cAAc;IAChB;;IAEA;MACE,2BAA2B;MAC3B,4BAA4B;MAC5B,2BAA2B;MAC3B,wBAAwB;MACxB,sBAAsB;IACxB;;IAEA;MACE,+BAA+B;MAC/B,gBAAgB;MAChB,SAAS;MACT,oCAAoC;MACpC,2BAA2B;IAC7B;;IAEA;MACE,+BAA+B;MAC/B,kBAAkB;MAClB,gBAAgB;MAChB,UAAU;MACV,SAAS;MACT,cAAc;MACd,yBAAyB;IAC3B;;IAEA;MACE,aAAa;MACb,WAAW;IACb;;IAEA;MACE,gBAAgB;MAChB,kBAAkB;MAClB,sCAAsC;MACtC,WAAW;MACX,YAAY;;MAEZ;QACE,gCAAgC;MAClC;IACF;EACF;AACF;;AAEA,mBAAmB;AACnB;EACE;IACE,iBAAiB;IACjB;MACE,gBAAgB;MAChB,kBAAkB;MAClB,6BAA6B;MAC7B,qBAAqB;;MAErB,SAAS;IACX;;IAEA;MACE,aAAa;IACf;;IAEA;MACE,yBAAyB;MACzB,gBAAgB;MAChB,uBAAuB;IACzB;;IAEA;MACE,kBAAkB;MAClB,kBAAkB;IACpB;EACF;AACF","sourcesContent":["/* \n// ─────────────────────────────────────────────────────────────────────────────\n// HOME PAGE STYLES\n// Below-the-fold styles for the homepage that load after critical styles.\n// The first section of the home page should go in critical.scss, while the\n// rest of the home page styles go in here.\n// ─────────────────────────────────────────────────────────────────────────────\n*/\n\n/* ******************* */\n/*       FEATURES      */\n/* ******************* */\n\n@media only screen and (min-width: 0rem) {\n  #features {\n    .title {\n      margin-bottom: 0;\n      line-height: 1.4em;\n    }\n\n    .text {\n      margin-bottom: calc(16 / 16 * 1rem);\n      font-size: 0.8125rem;\n      line-height: 2em;\n    }\n\n    .container {\n      width: 100%;\n      max-width: calc(1280 / 16 * 1rem);\n      margin: auto;\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      /* 48px - 64px */\n      gap: clamp(3rem, 6vw, 4rem);\n    }\n\n    .content {\n      /* set text align to left if content needs to be left aligned */\n      text-align: left;\n      width: 100%;\n      max-width: calc(542 / 16 * 1rem);\n      display: flex;\n      flex-direction: column;\n      /* centers content horizontally, set to flex-start to left align */\n      align-items: flex-start;\n      gap: 1.5rem;\n      padding: 0 1.625rem;\n      text-align: center;\n    }\n\n    .feature-list {\n      display: flex;\n      flex-direction: column;\n      gap: 2.5rem;\n      li {\n        list-style: none;\n        padding-left: 1rem;\n\n        .header {\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          gap: 1rem;\n          background-color: var(--color-primary-very-light);\n          border-radius: 2.4375rem 0 0 2.4375rem;\n          margin-bottom: 0.5rem;\n\n          .button-solid {\n            padding: 0.5rem 1.5rem;\n            border-radius: 2.4375rem;\n            font-size: 1rem;\n            line-height: 1.4em;\n          }\n\n          .button-solid:hover:before {\n            width: 0;\n          }\n\n          .title {\n            font-size: 1rem;\n          }\n        }\n\n        .text {\n          margin-bottom: 0;\n          padding-right: 1rem;\n        }\n      }\n    }\n  }\n}\n\n/* Desktop - 1024px */\n@media only screen and (min-width: 64rem) {\n  #features {\n    padding: 0 10.3125rem;\n    .container {\n      flex-flow: row;\n      justify-content: space-between;\n      align-items: flex-start;\n      gap: calc(125 / 16 * 1rem);\n      margin: auto;\n    }\n\n    .content {\n      padding: 0;\n      flex: 0 0 auto;\n      max-width: calc(500 / 16 * 1rem);\n    }\n\n    .feature-list {\n      flex: 1;\n    }\n\n    .feature-list li {\n      padding-left: 0;\n      .header {\n        background-color: transparent;\n      }\n\n      .text {\n        max-width: calc(449 / 16 * 1rem);\n        margin-left: 5.125rem;\n      }\n    }\n\n    .title {\n      text-align: start;\n    }\n\n    .text {\n      text-align: start;\n      font-size: 1rem;\n      line-height: 1.625em;\n      max-width: calc(350 / 16 * 1rem);\n    }\n\n    .content {\n      margin: 0;\n    }\n  }\n}\n\n/* ******************* */\n/*      REVIEWS        */\n/* ******************* */\n\n@media only screen and (min-width: 0rem) {\n  #reviews {\n    padding: var(--section-padding);\n    padding-top: calc(112 / 16 * 1rem);\n    .container {\n      width: 100%;\n      /* max-width: calc(1280 / 16 * 1rem); */\n      display: flex;\n      flex-direction: column;\n      align-items: center;\n      /* 48px - 64px */\n      gap: clamp(2.5rem, 6vw, 4rem);\n    }\n\n    .content {\n      /* set text align to left if content needs to be left aligned */\n      text-align: center;\n      width: 100%;\n      display: flex;\n      flex-direction: column;\n      /* centers content horizontally, set to flex-start to left align */\n      align-items: center;\n\n      .title {\n        margin-bottom: 0;\n      }\n    }\n\n    .card-container {\n      padding: 0;\n      margin: 0;\n      padding-top: 4rem;\n      display: flex;\n      column-gap: calc(20 / 16 * 1rem);\n      row-gap: calc(64 / 16 * 1rem);\n      overflow: hidden;\n\n      /* For dragging */\n      cursor: grab;\n      user-select: none;\n      scroll-behavior: smooth;\n    }\n\n    .card-container.dragging {\n      cursor: grabbing;\n      scroll-behavior: auto;\n    }\n\n    .item {\n      text-align: center;\n      list-style: none;\n      width: 100%;\n      max-width: calc(630 / 16 * 1rem);\n      background-color: var(--color-gray-50);\n      /* Padding L & R - 16px - 32px */\n      padding: 0 clamp(1rem, 3.2vw, 2rem) 0;\n      /* 32px - 40px */\n      padding-bottom: clamp(2rem, 5.4vw, 2.5rem);\n      position: relative;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      gap: 1.5rem;\n      flex-shrink: 0;\n    }\n\n    .item-img {\n      width: calc(80 / 16 * 1rem);\n      height: calc(80 / 16 * 1rem);\n      transform: translateY(-50%);\n      transform-origin: center;\n      margin-bottom: -1.5rem;\n    }\n\n    .text {\n      font-size: calc(13 / 16 * 1rem);\n      line-height: 2em;\n      margin: 0;\n      padding-bottom: calc(20 / 16 * 1rem);\n      color: var(--bodyTextColor);\n    }\n\n    .name {\n      font-size: calc(16 / 16 * 1rem);\n      line-height: 1.5em;\n      font-weight: 700;\n      width: 40%;\n      margin: 0;\n      display: block;\n      color: var(--headerColor);\n    }\n\n    .dots {\n      display: flex;\n      gap: 0.5rem;\n    }\n\n    .dot {\n      background: none;\n      border-radius: 50%;\n      border: 1px solid var(--color-primary);\n      width: 12px;\n      height: 12px;\n\n      &.active {\n        background: var(--color-primary);\n      }\n    }\n  }\n}\n\n/* Tablet - 768px */\n@media only screen and (min-width: 48rem) {\n  #reviews {\n    padding-inline: 0;\n    .card-container {\n      overflow-x: auto;\n      overflow-y: hidden;\n      scroll-snap-type: x mandatory;\n      scrollbar-width: none;\n\n      gap: 2rem;\n    }\n\n    .card-container::-webkit-scrollbar {\n      display: none;\n    }\n\n    .item {\n      scroll-snap-align: center;\n      max-width: 460px;\n      padding-inline: 2.75rem;\n    }\n\n    .dots {\n      visibility: hidden;\n      position: absolute;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
